<div [ngClass]="isEditing?'parameters':'parameters hidden'">
  <dx-accordion #accordion [dataSource]="sections" [animationDuration]="1" [collapsible]="true" [multiple]="false"
    [selectedIndex]="-1">
    <div *dxTemplate="let section of 'title'">
      <span>{{section.title}} : </span>
      <span *ngIf="!(section.error || section.warning)" style="color:#00919b">{{section.summary}}</span>
      <span *ngIf="section.error" style="color:red">{{section.error}}</span>
      <span *ngIf="section.warning && !section.error" style="color:#FF5200">{{section.warning}}</span>
    </div>
    <div *dxTemplate="let section of keys.pipeWorkSection" style="background:#EAF4F5">
      <app-pipe-form (change)="setPipeworkSectionSummary()" style="padding:10px" [(pipes)]="pipes" [errors]="errors"
        (editing)="setEditingPipeWork($event)">
      </app-pipe-form>
    </div>
    <div *dxTemplate="let section of keys.gasSection" style="background:#EAF4F5;padding-top:20px">
      <lib-gas-selector (valueChange)="setGas($event)" [(temperature)]="gasTemperature"
        [error]="errors['gasEntryTemperature']"></lib-gas-selector>
    </div>
    <div *dxTemplate="let section of keys.boundaryConditionsSection" style="background:#EAF4F5">
      <app-boundary-condition-form [errors]="errors" (conditionChanged)="setBoundaries($event)">
      </app-boundary-condition-form>
    </div>
    <div *dxTemplate="let section of keys.rangeOnVariableSection" style="background:#EAF4F5">
      <app-range-variable (valueChange)="rangeVariableChange($event)" [pipes]="pipesForRangeVariables"
        [conditions]="conditions" [errors]="errors"></app-range-variable>
    </div>
  </dx-accordion>
  <div style="padding-top:20px;padding-bottom:20px">
    <dx-button text="Calculate" (onClick)="getPendingUpdatesAndCalculate()" [disabled]="calculating"></dx-button>
    <span style="padding-left:20px"></span>
    <dx-button text="Cancel" (onClick)="cancelCalculation()" [disabled]="!calculating"></dx-button>
  </div>
  <div *ngIf="solverError" style="color:red">Invalid Parameters - {{solverError}}</div>
  <status-bar [status]="calculationStatus"></status-bar>
</div>

<div [ngClass]="isEditing?'hidden':'parameters-summary'">
  <div *ngFor="let section of sections" class="parameters-summary-section">
    <span class="parameters-summary-title">{{section.title}} : </span>
    <span class="parameters-summary-summary">{{section.summary}}</span>
  </div>
  <div style="padding-right:10px">
    <dx-button text="Edit" (onClick)="edit()"></dx-button>
  </div>

</div>
